<template>
  <div class="pageview">
        <!-- 查询表单 -->
    <div class="query-form">
      <van-cell-group inset>
        <van-field
          v-model="queryParams.name"
          label="名称"
          placeholder="请输入名称"
          clearable
          @keypress.enter="handleQuery"
        />
        <van-field
          v-model="queryParams.content"
          label="内容"
          placeholder="请输入内容"
          clearable
          @keypress.enter="handleQuery"
        />

        <!-- 日期范围选择 -->
        <van-field
          readonly
          clickable
          label="类型"
          :value="selectedTypeName"
          placeholder="选择类型"
          @click="showTypePicker = true"
        />
      </van-cell-group>

      <!-- 操作按钮 -->
      <div class="query-actions">
        <van-button type="primary" size="small" @click="queryFun">查询</van-button>
        <van-button size="small" @click="resetQuery">重置</van-button>
        <van-button type="primary" size="small" @click="$refs.searchInfo.addCreateForm(platForm)">图片搜索</van-button>
        <van-button type="primary" plain size="small" @click="$refs.addImageLibrary.addCreateForm(platForm, userName)">
          新增
        </van-button>
      </div>
    </div>
    <!-- 搜索操作栏 -->
    <!-- <div class="search-actions" v-show="showSearch">
     
        <van-button type="primary" size="small" @click="queryFun">查询</van-button>
      <van-button
        type="primary"
        icon="search"
        size="small"
        @click="$refs.searchInfo.addCreateForm(platForm)"
        block
        >搜索</van-button
      >
      <div style="display: flex; margin-top: 8px">
        <van-button icon="replay" size="small" @click="resetQuery" style="flex: 1; margin-right: 8px"
          >重置</van-button
        >
        <van-button
          type="primary"
          plain
          icon="plus"
          size="small"
          @click="$refs.addImageLibrary.addCreateForm(platForm, userName)"
          style="flex: 1"
          >新增</van-button
        >
      </div>
    </div> -->

    <!-- 主内容区 -->
    <div class="content-wrap" v-if="!searchShow">
      <!-- 卡片列表 -->
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多数据了"
        @load="onLoad"
      >
        <div class="card-list">
          <div
            class="card-item"
            v-for="(item, index) in dataList"
            :key="index"
            @click="$refs.detailsInfo.addCreateForm(item)"
          >
            <!-- 图片 -->
            <div class="card-img">
              <image-preview v-if="item.url" :src="item.url" :width="60" :height="60" />
            </div>

            <!-- 信息 -->
            <div class="card-info">
              <div class="card-row">
                <span class="label">名称：</span>
                <span class="value">{{ item.name || '无' }}</span>
              </div>
              <div class="card-row">
                <span class="label">类型：</span>
                <span class="value">
                  <span v-for="(typeItem, i) in item.imageTypeList" :key="i">{{ typeItem.type }} </span>
                </span>
              </div>
              <div class="card-row">
                <span class="label">内容：</span>
                <span class="value van-multi-ellipsis--l2">{{ item.content || '无' }}</span>
              </div>
              <div class="card-row">
                <span class="label">创建人：</span>
                <span class="value">{{ item.createUser }}</span>
              </div>
            </div>

            <!-- 操作按钮 -->
            <div class="card-actions">
              <van-button size="small" type="primary" plain @click.stop="$refs.addImageLibrary.showCreateForm(item)">修改</van-button>
              <van-button size="small" type="danger" plain @click.stop="handleDelete(item)">删除</van-button>
            </div>
          </div>
        </div>
      </van-list>
    </div>

    <!-- 搜索结果：图片墙模式 -->
        <div class="content-wrap" v-if="searchShow">
      <!-- 卡片列表 -->
  
        <div class="card-list">
          <div
            class="card-item"
            v-for="(item, index) in dataList"
            :key="index"
            @click="$refs.detailsInfo.addCreateForm(item.list)"
          >
            <!-- 图片 -->
            <div class="card-img">
              <image-preview v-if="item.list.url" :src="item.list.url" :width="60" :height="60" />
            </div>

            <!-- 信息 -->
            <div class="card-info">
              <div class="card-row">
                <span class="label">名称：</span>
                <span class="value">{{ item.list.name || '无' }}</span>
              </div>
              <div class="card-row">
                <span class="label">相似度：：</span>
                <span class="value">
                {{ item.score }}
                </span>
              </div>
            </div>

            <!-- 操作按钮 -->
            <!-- <div class="card-actions">
              <van-button size="small" type="primary" plain @click.stop="$refs.addImageLibrary.showCreateForm(item.list)">修改</van-button>
              <van-button size="small" type="danger" plain @click.stop="handleDelete(item.list)">删除</van-button>
            </div> -->
          </div>
        </div>
    </div>
    <!-- <div class="faceDatabase" v-else>
      <van-grid clickable :column-num="2" :border="false">
        <van-grid-item v-for="(item, index) in dataList" :key="index" @click="$refs.detailsInfo.addCreateForm(item.list)">
          <van-image :src="item.list.url" width="80" height="80" radius="8" />
          <template slot="title">
            <div class="grid-text">
              <div>{{ item.list.name }}</div>
              <div>相似度：{{ item.score }}</div>
            </div>
          </template>
        </van-grid-item>
      </van-grid>
      <van-empty description="暂无内容" v-if="dataList.length === 0" />
    </div> -->
 <!-- 类型选择 Picker -->
       <!-- 弹出选择器 -->
    <van-popup v-model="showTypePicker" position="bottom" :style="{ height: '50%' }">
      <van-picker
       show-toolbar
        :columns="pickerColumns"
        @confirm="onConfirm"
        @cancel="showTypePicker = false"
        confirm-button-text="确定"
        cancel-button-text="取消"
      />
    </van-popup>
    <!-- 子组件（逻辑不变） -->
    <addImageLibraryVant ref="addImageLibrary" @ok="handleOkAfterAdd" />
    <searchInfoVant ref="searchInfo" @ok="searchFun" />
    <detailsInfoVant ref="detailsInfo" />
  </div>
</template>

<script>
import { imageLibraryList, imageLibraryDel } from "@/api/imageLibrary";
import addImageLibraryVant from "@/views/system/imageLibrary/addImageLibraryVant";
import searchInfoVant from "@/views/system/imageLibrary/searchInfoVant";
import detailsInfoVant from "@/views/system/imageLibrary/detailsInfoVant";
import { imageTypeList } from "@/api/imageType";
import "@/assets/imgList.css";

export default {
  components: {
    addImageLibraryVant,
    searchInfoVant,
    detailsInfoVant,
  },
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        platForm: "luoshanxian",
          name: null,
        content: null,
        type: null,
      },
      loading: false,
      finished: false,
      dataList: [],
      showSearch: true,
      platForm: "",
      userName: "",
      userId: "",
      oriApi: "",
      searchShow: false,
      showTypePicker: false,
      typeList: [],
      selectedTypeName: ''
    };
  },
   computed: {
    // 将 typeList 转为 Picker 的 columns（只显示 label）
    pickerColumns() {
      return this.typeList.map(item => item.type);
    },
  },
  created() {},
  mounted() {
    this.userId = this.$route.query.userId;
    this.userName = this.$route.query.userName;
    this.platForm = this.$route.query.platForm;
    this.oriApi = this.$route.query.oriApi;
    this.queryParams.platForm = this.platForm;
    // 初始加载第一页
    this.onLoad();
    this.getTypeList();
  },
  methods: {
    // 触底加载
    onLoad() {
      this.loading = true;
      imageLibraryList(this.queryParams)
        .then((response) => {
          const result = response.data.data;
          const list = result.list || [];
          this.dataList = this.dataList.concat(list);
          this.total = result.total;

          // 判断是否加载完毕
          if (this.dataList.length >= this.total || list.length === 0) {
            this.finished = true;
          } else {
            this.queryParams.pageNum += 1;
          }
        })
        .catch(() => {
          this.finished = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
      getTypeList() {
      imageTypeList({
        pageNum: 1,
        pageSize: 1000,
        platForm: this.platForm,
      }).then((response) => {
        const result = response.data.data;
        console.log(result);
        this.typeList = result.list;
      });
    },
    onConfirm(value, index) {
      // value 是选中的 text（如 "电子产品"）
      // 我们需要回传对应的 id
      const selectedItem = this.typeList[index];
      console.log(selectedItem);
      this.queryParams.type = selectedItem.id;
      this.selectedTypeName = selectedItem.type;
      this.showTypePicker = false;
    },
   // 查询（重置页码）
    queryFun() {
      this.queryParams.pageNum = 1;
      this.dataList = [];
      this.finished = false;
      this.onLoad();

    },
    // 搜索结果处理
    searchFun(list) {
      this.searchShow = true;
      this.dataList = list;
    },

    // 删除
    handleDelete(row) {
      const ids = row.id;
      this.$dialog
        .confirm({
          title: "确认删除",
          message: `是否确认删除编号为 "${ids}" 的数据项？`,
        })
        .then(() => {
          return imageLibraryDel({ id: ids });
        })
        .then(() => {
          this.$toast.success("删除成功");
          this.handleResetList(); // 重置列表，重新加载
        })
        .catch(() => {});
    },

    // 重置列表（用于删除后刷新）
    handleResetList() {
      this.dataList = [];
      this.queryParams.pageNum = 1;
      this.finished = false;
      this.searchShow = false
      this.onLoad();
    },

    // 新增或修改后刷新
    handleOkAfterAdd() {
      this.handleResetList();
    },

    // 重置查询条件
    resetQuery() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        platForm: this.platForm,
        name: null,
        content: null,
        type: null,
      };
      this.selectedTypeName = ''
      this.handleResetList();
    },
  },
};
</script>

<style scoped>
.pageview {
  padding: 12px;
  background-color: #f7f8fa;
  min-height: 100vh;
}

.search-actions {
  margin-bottom: 16px;
}

.content-wrap {
  margin-top: 8px;
}

/* 卡片列表 */
.card-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.card-item {
  background-color: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  padding: 12px;
  position: relative;
}

.card-img {
  float: right;
  margin-left: 12px;
}

.card-info {
  font-size: 14px;
  color: #333;
}

.card-row {
  display: flex;
  margin-bottom: 6px;
  font-size: 13px;
}

.label {
  color: #666;
  font-weight: 500;
  min-width: 50px;
}

.value {
  color: #333;
  flex: 1;
}

.card-actions {
  margin-top: 12px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

/* 图片墙模式 */
.faceDatabase {
  margin-top: 16px;
}

.grid-text {
  font-size: 12px;
  text-align: center;
  margin-top: 4px;
  color: #666;
}

.van-empty {
  margin-top: 40px;
}
.query-actions {
  padding: 10px;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  background: #f9f9f9;
}
</style>